import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ProductsList } from "./ProductsList"; // assuming you have all products here
import ProductCard from "./ProductCard"; // your existing component
import { ArrowLeft } from "lucide-react";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function SearchResults() {
  const query = useQuery().get("q")?.toLowerCase() || "";
  const navigate = useNavigate();
  // Filter products using the query
  const filteredProducts = Object.values(ProductsList)
    .flatMap((cat) => cat.products) // flatten all products across categories
    .filter((product) => {
      return (
        product.name.toLowerCase().includes(query) ||
        product.description.toLowerCase().includes(query) &
          product.category.toLocaleLowerCase().includes(query)
      );
    });

  return (
    <>
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-gray-700 hover:text-[#fe7590] cursor-pointer"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back
          </button>
        </div>
      </header>
      <div className="max-w-6xl mx-auto p-6">
        <h2 className="text-2xl font-bold mb-6">
          Search Results for: <span className="text-[#fe7590]">"{query}"</span>
        </h2>

        {filteredProducts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-4 gap-[100px]">
            {filteredProducts.map((product, i) => (
              <ProductCard key={i} product={product} />
            ))}
          </div>
        ) : (
          <p className="text-gray-500">No products found.</p>
        )}
      </div>
    </>
  );
}
